import React from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';

import { withStyles } from '@material-ui/core';

import TimePicker from '../Inputs/TimePicker';

const styles = ({ palette }) => ({
  inputGroup: {
    width: '100%',
    display: 'flex'
  },
  control: {
    flexShrink: 0,
    height: 34
  },
  addon: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 auto',
    height: 34,
    color: palette.text.color,
    background: palette.disabled
  },
  addonContent: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
});

function FormTimePicker({
  input: { value, onChange },
  meta: { valid, submitFailed },
  title,
  placeholder,
  prefix,
  postfix,
  format,
  mouseInKey,
  isRequired,
  errorMessage,
  classes,
  ...pickerOptions
}) {
  const time = dayjs(value, format);
  const viewTime = time.isValid() ? time : dayjs('0:00:00', format);

  return (
    <TimePicker
      label={title}
      mouseInKey={mouseInKey}
      value={viewTime}
      onChange={onChange}
      format={format}
      isRequired={isRequired}
      isValid={!submitFailed || valid}
      placeholder={placeholder}
      errorText={errorMessage}
      {...pickerOptions}
    />
  );
}

FormTimePicker.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  prefix: PropTypes.string,
  postfix: PropTypes.string,
  format: PropTypes.string,
  mouseInKey: PropTypes.string,
  isRequired: PropTypes.bool,
  errorMessage: PropTypes.string,

  classes: PropTypes.object
};

FormTimePicker.defaultProps = {
  meta: {
    valid: true,
    submitFailed: false
  },
  title: null,
  placeholder: '',
  prefix: null,
  postfix: null,
  format: 'HH:mm',
  mouseInKey: '',
  isRequired: false,
  errorMessage: null,

  classes: {}
};

export default withStyles(styles)(FormTimePicker);
